import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { MESSAGE_MODALS } from '../../context/custom/MessageModalContext';
import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { ServerRequest } from '../../utils/apiweb';
import { TableCustom, SectionHeading, FooterButtonVolver } from '../../components/common';
import OrganoJudicialModal from '../../components/controls/OrganoJudicialModal';
import { useManagedContext, usePermissions } from '../../components/hooks';
import { standardRequest } from '../../utils/requests';
import { useSearchParams } from "react-router-dom";
import { PERMISSIONS } from '../../consts/permissions';

function OrganosJudicialesView() {
    const { setIsLoading, showMessageModal } = useManagedContext()
    const { hasPermission } = usePermissions();
    const [searchParams] = useSearchParams();
    const location = useLocation()
    const previousFilters = location.state?.filters
    const canEdit = hasPermission(PERMISSIONS.APREMIO_EDIT ?? 'apremio_edit');
    const isViewOnly = searchParams.get('mode') === OPERATION_MODE.VIEW;
    const allowEditActions = canEdit && !isViewOnly;

    //hooks
    const [state, setState] = useState({
        showForm: false,
        modeFormEdit: false,
        rowId: 0,
        list: []
    });

    const mount = () => {

        SearchOrganosJudiciales();
        
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    //definiciones
    const tableColumns = [
        { Header: 'Órgano judicial', accessor: 'codigoOrganoJudicial', width: '25%' },
        { Header: 'Departamento judicial', accessor: 'departamentoJudicial', width: '25%' },
        { Header: 'Fuero', accessor: 'fuero', width: '20%' },
        { Header: 'Secretaría', accessor: 'secretaria', width: '20%' },
    ];

    //handles
    const avmr = {
        onAdd: () => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: 0}))
        },
        onView: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: false, rowId: parseInt(id)}))
        },
        onModify: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: parseInt(id)}))
        },
        onRemove: ({ id }) => {
            const item = state.list.find(x => x.id === id)
            showMessageModal({
                ...MESSAGE_MODALS.BORRAR,
                message: `¿Está seguro de borrar el organo judicial ${item.codigoOrganoJudicial}?`,
                onConfirm: () => {
                    setIsLoading(true)
                    standardRequest(REQUEST_METHOD.DELETE, `${APIS.URLS.ORGANO_JUDICIAL}/${id}`)
                    .then(() => SearchOrganosJudiciales())
                    .catch(() => {})
                    .finally(() => setIsLoading(false))
                }
            })
        },
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setIsLoading(false)
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setIsLoading(false)
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setIsLoading(false)
    }

    //funciones
    function SearchOrganosJudiciales() {
        setIsLoading(true)
        setState(prev => ({ ...prev, list: [], }))

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                data.forEach(x => {
                    if (x.fechaCreacion) x.fechaCreacion = new Date(x.fechaCreacion);
                });
                setIsLoading(false)
                setState(prev => ({ ...prev, list: data }))
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };


        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.ORGANO_JUDICIAL,
            null,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
    <>
        {state.showForm && 
            <OrganoJudicialModal
                id={state.rowId}
                disabled={!state.modeFormEdit}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false};
                    });
                }}
                onConfirm={(id) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowId: 0};
                    });
                    SearchOrganosJudiciales();
                }}
            />
        }

        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas', url: '/entidades' }, { title: 'Órganos judiciales'}]}
                        onAddClick={allowEditActions ? avmr.onAdd : null} />

        <section className='section-accordion'>

            <div className="m-top-20">

                <TableCustom
                    className={'TableCustomBase'}
                    columns={tableColumns}
                    data={state.list}
                    avmr={avmr}
                    editCode={PERMISSIONS.APREMIO_EDIT}
                    disabled={!allowEditActions}
                />

            </div>

        </section>
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>
        
    </>
    )
}

export default OrganosJudicialesView;
